(function () {

    const section = document.querySelector(`[id="product"]`);
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // get orders sold
    fetch("https://cdn.vktry.com/order-count.json")
        .then(response => response.json())
        .then(response => {
            // show badge only if there are orders
            if (response.gold_order_count && response.gold_order_count > 0) {
                // format number with commas
                const ordersSoldCommas = response.gold_order_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                section.querySelector("#productSoldTxt").innerHTML = `${ordersSoldCommas} Sold <br> In Last 7 Days`;
                section.querySelector("#productSold").classList.add("active");
            }
        })


    // set up images swiper
    let productSwiper = new Swiper('#productSwiper', {
        slidesPerView: 1,
        spaceBetween: 50,
        autoHeight: true,
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productThumbsItem").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });


    // update active variant
    let formData = {
        items: []
    };

    // top cover is based off of sport (GOLD INSOLES)
    const sportToTopCover = {
        "Baseball/Softball": "B",
        "Basketball": "A",
        "Ultimate Frisbee": "B",
        "Wrestling/Boxing": "B",
        "Cheerleading": "C",
        "Fitness": "A",
        "Golf": "B",
        "Hiking": "A",
        "Football": "B",
        "Lacrosse": "B",
        "Rugby": "B",
        "Running": "A",
        "Soccer": "C",
        "Tennis/Pickleball": "A",
        "Track & Field": "C",
        "Volleyball": "A",
        "Walking": "A",
        "Other": "A",
        "Ice Hockey": "C",
    }

    // slide order used to clear later answers when an earlier one changes
    const optionGroups = ["gender", "sport", "size", "weight", "age"];

    // possible gender/age values come from the rendered labels so Liquid stays the source of truth
    const genderValues = Array.from(section.querySelectorAll(`.productFormOptionSlideLabel[data-group="gender"]`)).map(element => element.dataset.value);
    const ageValues = Array.from(section.querySelectorAll(`.productFormOptionSlideLabel[data-group="age"]`)).map(element => element.dataset.value);

    /**
     * Check if a partial selection can still end at a variant we carry, sold out or not.
     * Missing answers are wildcards: they are enumerated over every value they could still take.
     * @param {{gender?: string, sport?: string, size?: string, weight?: string, age?: string}} options partial selection
     * @returns {boolean} true when at least one completion of the missing answers is a variant we carry
     */
    function canComplete(options) {
        // assume possible on templates that do not render the gold product globals
        if (typeof goldWeightToProduct === "undefined") {
            return true;
        }

        // unknown answers are enumerated over every value they could still take
        const genders = options.gender ? [options.gender] : genderValues;
        const weights = options.weight ? [options.weight] : Object.keys(goldWeightToProduct);
        const ages = options.age ? [options.age] : ageValues;
        const topCover = options.sport ? sportToTopCover[options.sport] : null;

        // possible iff any routing triple resolves to a product that carries a matching variant
        return genders.some(gender => weights.some(weight => ages.some(age =>
            hasCarriedVariant(resolveTargetProduct(weight, age, gender), {size: options.size ?? null, topCover, gender})
        )));
    }

    /**
     * Check if a product carries any variant matching the (possibly partial) filters.
     * Stock is deliberately ignored: a sold out variant is still one we carry, so it must not
     * gray out the choice that leads to it.
     * @param {Object} targetProduct Shopify product JSON
     * @param {{size: ?string, topCover: ?string, gender: ?string}} filters values to match, null matches anything
     * @returns {boolean} true when at least one matching variant exists, in stock or not
     */
    function hasCarriedVariant(targetProduct, filters) {
        return targetProduct.variants.some(variant => variantMatches(variant, filters));
    }

    /**
     * Resolve which pro level product a weight/age/gender combination routes to.
     * @param {string} weight weight bracket key of goldWeightToProduct, e.g. "151 - 180lbs"
     * @param {string} age age bracket, e.g. "21 - 30" ("50 and Up" drops one pro level)
     * @param {string} gender "Male" | "Female" (Female at 151-180lbs steps down to L3)
     * @returns {Object} the pro level product JSON (goldProductL1/L3/L4/L5/L6)
     */
    function resolveTargetProduct(weight, age, gender) {
        // base product comes from the weight bracket
        let targetProduct = goldWeightToProduct[weight];

        // Note we do not touch the weight variable since it's used as a line item property
        // if they are Female and size 151-180, it changes the weight to pro level 3 from level 4 (we have another case for ages 50 and up so we exclude that)
        if (gender === "Female" && weight === "151 - 180lbs" && age !== "50 and Up") {
            targetProduct = goldWeightToProduct["121 - 150lbs"];
        }

        // if they are age 50 & up, we decrease the pro level by 1
        if (age === "50 and Up") {
            if (weight === "261lbs - Up") {
                targetProduct = goldWeightToProduct["231 - 260lbs"];
            } else if (weight === "231 - 260lbs" || weight === "211 - 230lbs") {
                targetProduct = goldWeightToProduct["181 - 210lbs"];
            } else if (weight === "181 - 210lbs" || weight === "151 - 180lbs") {
                targetProduct = goldWeightToProduct["121 - 150lbs"];
            } else if (weight === "121 - 150lbs") {
                targetProduct = goldWeightToProduct["100 - 120lbs"];
            } else {
                targetProduct = goldWeightToProduct["100 - 120lbs"];
            }
        }

        return targetProduct;
    }

    /**
     * Check a variant against partial filters, null fields act as wildcards.
     * @param {Object} variant Shopify variant JSON (option1 size range, option2 top cover, option3 gender)
     * @param {{size: ?string, topCover: ?string, gender: ?string}} filters values to match, null matches anything
     * @returns {boolean} true when the variant satisfies every non-null filter
     */
    function variantMatches(variant, filters) {
        // size ranges like "5-5.5" are split so the exact size can be matched
        if (filters.size !== null && !variant.option1.split("-").includes(filters.size)) {
            return false;
        }

        // top cover letter
        if (filters.topCover !== null && variant.option2 !== filters.topCover) {
            return false;
        }

        // gender
        if (filters.gender !== null && variant.option3 !== filters.gender) {
            return false;
        }

        return true;
    }

    /**
     * Read the currently selected wizard answers into a partial options object.
     * @returns {Object} answered groups only, e.g. {gender: "Female", sport: "Basketball"}
     */
    function getSelectedOptions() {
        let options = {};
        section.querySelectorAll(".productFormOptionSlideLabel.active").forEach(element => {
            options[element.dataset.group] = element.dataset.value;
        });
        return options;
    }

    /**
     * Gray out every wizard choice that can only lead to variants we do not carry.
     * Sold out variants are still carried, so they never gray a choice out.
     * Clicking a label clears every later answer, so each label is constrained only by
     * answers on slides before it, and the first slide is never grayed.
     */
    function refreshDisabledOptions() {
        const selected = getSelectedOptions();

        section.querySelectorAll(".productFormOptionSlideLabel").forEach(element => {
            const group = element.dataset.group;

            // the first slide always stays fully clickable
            if (group === optionGroups[0]) {
                element.classList.remove("soldOut");
                return;
            }

            // clicking a label clears every later answer, so only earlier answers constrain it
            let options = {[group]: element.dataset.value};
            optionGroups.slice(0, optionGroups.indexOf(group)).forEach(earlierGroup => {
                if (selected[earlierGroup]) {
                    options[earlierGroup] = selected[earlierGroup];
                }
            });

            element.classList.toggle("soldOut", !canComplete(options));
        });
    }

    /**
     * Disable dead-end choices inside a pair modal and reset selects that just became invalid.
     * Mirrors refreshDisabledOptions: each select is constrained only by the selects before it
     * in the wizard order, and later selects whose value became invalid reset to the placeholder.
     * @param {Element} pairElement the .productFormPair containing the modal to refresh
     */
    function refreshPairModalDisabledOptions(pairElement) {
        const selects = pairElement.querySelectorAll(".productFormPairModalLabelSelect");

        // read the current answers, treating the "Choose ..." placeholder as unanswered
        let current = {};
        selects.forEach(select => {
            if (select.selectedIndex > 0) {
                current[select.getAttribute("name")] = select.value;
            }
        });

        // disable every choice that can no longer end at a variant we carry
        selects.forEach(select => {
            const name = select.getAttribute("name");

            // invalid later answers auto-reset below, so only earlier answers constrain a select
            let earlierOptions = {};
            optionGroups.slice(0, optionGroups.indexOf(name)).forEach(earlierGroup => {
                if (current[earlierGroup]) {
                    earlierOptions[earlierGroup] = current[earlierGroup];
                }
            });

            select.querySelectorAll("option").forEach((option, index) => {
                if (index === 0) {
                    return;
                }
                option.disabled = !canComplete({...earlierOptions, [name]: option.value});
            });
        });

        // reset any select whose chosen value just became disabled, then re-check with the widened answers
        let resetNeeded = false;
        selects.forEach(select => {
            if (select.selectedIndex > 0 && select.options[select.selectedIndex].disabled) {
                select.selectedIndex = 0;
                resetNeeded = true;
            }
        });
        if (resetNeeded) {
            refreshPairModalDisabledOptions(pairElement);
            return;
        }

        // keep the update button in sync since programmatic resets do not fire change events
        let ready = true;
        selects.forEach(select => {
            if (select.selectedIndex === 0) {
                ready = false;
            }
        });
        pairElement.querySelector(".productFormPairModalUpdate").disabled = !ready;
    }

    // initial pass so globally dead choices (e.g. sizes no product carries) are grayed from the start
    refreshDisabledOptions();

    // function to take variables from product options to a formdata item
    function getFormData(options, targetHandle) {
        // gender is a variant (make sure something is checked)
        let gender = options.gender ?? null;

        // sport is a property
        let sport = options.sport ?? null;

        // size is a variant
        let size = options.size ?? null;

        // weight is a property
        let weight = options.weight ?? null;

        // age is a property
        let age = options.age ?? null;

        // Determine product
        let targetProduct = goldWeightToProduct[weight];


        // Determine Top Cover
        let topCover = sportToTopCover[sport];

        // overrides
        // AFTER determining the product (based on the weight) we check on special cases
        // Note we do not touch the weight variable since it's used as a line item property
        // if they are Female and size 151-180, it changes the weight to pro level 3 from level 4 (we have another case for ages 50 and up so we exclude that)
        if (gender === "Female" && weight === "151 - 180lbs" && age !== "50 and Up") {
            targetProduct = goldWeightToProduct["121 - 150lbs"];
        }

        // if they are age 50 & up, we decrease the pro level by 1
        // if they are age 50 & up, we decrease the pro level by 1
        if (age === "50 and Up") {
            if (weight === "261lbs - Up") {
                targetProduct = goldWeightToProduct["231 - 260lbs"];
            } else if (weight === "231 - 260lbs" || weight === "211 - 230lbs") {
                targetProduct = goldWeightToProduct["181 - 210lbs"];
            } else if (weight === "181 - 210lbs" || weight === "151 - 180lbs") {
                targetProduct = goldWeightToProduct["121 - 150lbs"];
            } else if (weight === "121 - 150lbs") {
                targetProduct = goldWeightToProduct["100 - 120lbs"];
            } else {
                targetProduct = goldWeightToProduct["100 - 120lbs"];
            }
        }


        // find the correct variant based on the active options
        let activeVariant = null;
        for (let i = 0; i < targetProduct.variants.length; i++) {

            // here comes the tricky part, Shopfiy might have 5-5.5 OR 5.5-6 ending on the top cover however we're going to receive a size of 5, 5.5 or 6.
            // We need to do a split and find an exact match
            if (
                // size
                targetProduct.variants[i].option1.split("-").includes(size) &&
                // top cover
                targetProduct.variants[i].option2 === topCover &&
                // gender
                targetProduct.variants[i].option3 === gender
            ) {
                activeVariant = targetProduct.variants[i];
                break;
            }
        }


        // check if active variant is not found in any setup
        if (activeVariant == null) {
            return false;
        }

        // gather item
        let formData = {
            quantity: 1,
            id: activeVariant.id,
            properties: {
                "Age": age,
                "Sport": sport,
                "Weight": weight
            },
            available: activeVariant.available
        };

        // return
        return formData;

    }

    /**************
     Product Slider
     ***************/

        // enable swiper
    let productFormSwiper = new Swiper(".productFormSwiper", {
            allowTouchMove: false,
            autoHeight: true,
            spaceBetween: 30
        });


    // Progress bar
    productFormSwiper.on("slideChange", function () {
        // enable all buttons
        section.querySelectorAll('.productFormProgressCircleInner').forEach((element) => {
            element.disabled = false;
        });


        // update active progress bar circles
        section.querySelectorAll(".productFormProgressCircle")?.forEach((element, index) => {
            if (index <= productFormSwiper.activeIndex) {
                // we need to wait to add the active class
                // because the progress bar takes 300ms to animate
                setTimeout(() => {
                    element.classList.add("active");
                }, 100);
            } else {
                element.classList.remove("active");
            }
        });

        // update active progress bar lines
        section.querySelectorAll(".productFormProgressLineInner").forEach((element, index) => {
            element.classList.remove("active");
            if (index < productFormSwiper.activeIndex) {
                element.classList.add("active");
            }
        });

        // Progress bar button click slide change
        section.querySelectorAll('.productFormProgressCircle.active').forEach((element, index) => {
            element.addEventListener("click", function () {
                productFormSwiper.slideTo(index);
            });
        });

    });


    // Progress bar final slide edge cases
    // The final form is the last "slide" but isn't a swiper slide.
    // We need to add the active class to the final progress bar/circle when
    // the last swiper slide option is clicked, which is the weight group for platinum
    // and is the age group for silver/gold.
    let targetGroup = "age"


    section.querySelectorAll(`.productFormOptionSlideLabel[data-group='${targetGroup}']`)?.forEach(element => {
        element.addEventListener("click", function () {
            // ignore choices that lead only to variants we do not carry
            if (this.classList.contains("soldOut")) {
                return;
            }
            // add active class to all progress bar circles
            section.querySelectorAll(".productFormProgressCircle")?.forEach((element, index) => {
                element.classList.add("active");
            });
            // add active class to all progress bar lines
            section.querySelectorAll(".productFormProgressLineInner")?.forEach((element, index) => {
                element.classList.add("active");
            });

            // Since we're on the last slide, we need to disable the buttons
            section.querySelectorAll('.productFormProgressCircleInner').forEach((element) => {
                element.disabled = true;
            });
        });
    });


    // update active variant on click
    section.querySelectorAll(".productFormOptionSlideLabel").forEach(function (element) {
        element.addEventListener("click", function () {
            // ignore choices that lead only to variants we do not carry
            if (this.classList.contains("soldOut")) {
                return;
            }

            const group = this.dataset.group;
            const value = this.dataset.value;

            // remove active class from all items in this group
            section.querySelectorAll(`.productFormOptionSlideLabel[data-group="${group}"]`).forEach(element => element.classList.remove("active"));

            // add active class to this item
            this.classList.add("active");

            // recompute which upcoming choices are dead ends for the new selection
            refreshDisabledOptions();

            // go to next slide
            productFormSwiper.slideNext();

            // // slide back up to top of productFormSwiper - 200px - only on the shoe slide
            // if (group === "size") {
            //     let elementTop = section.querySelector('.productFormSwiper').getBoundingClientRect().top + window.scrollY;
            //     let offset = 300;
            //     if (window.innerWidth < 800) {
            //         offset = 250;
            //     }
            //     window.scrollTo({
            //         top: elementTop - offset,
            //         behavior: 'smooth'
            //     });
            // }

            // check if every group has an active item
            if (section.querySelectorAll(".productFormOptionSlide").length === section.querySelectorAll(".productFormOptionSlideLabel.active").length) {
                section.querySelector(".productFormWrap").classList.remove("active");
                section.querySelector(".productFormSwiper").classList.remove("active");
                section.querySelector(".productFormForm").classList.add("active");
            } else {
                section.querySelector(".productFormWrap").classList.add("active");
                section.querySelector(".productFormSwiper").classList.add("active");
                section.querySelector(".productFormForm").classList.remove("active");
                return;
            }

            // create options object
            let options = {};
            section.querySelectorAll(`.productFormOptionSlideLabel.active`).forEach(element => {
                options[element.dataset.group] = element.dataset.value;
            });

            // save options
            section.querySelector(".productFormPair").setAttribute("options", JSON.stringify(options));
            section.querySelector(".productFormPair").classList.add("active");


            // update product
            updateProduct();


        });
    })


    // back button
    section.querySelectorAll(".productFormSwiperNavBack").forEach(function (element) {
        element.addEventListener("click", function () {
            productFormSwiper.slidePrev();
        });
    });

    // next button
    section.querySelectorAll(".productFormSwiperNavNext").forEach(function (element) {
        element.addEventListener("click", function () {
            productFormSwiper.slideNext();
        });
    });

    /*******************
     * Product Pairs
     */

    // open edit
    section.querySelectorAll(".productFormPairEdit").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = this.closest(".productFormPair");

            // save option element
            let options = pairElement.getAttribute("options");

            // open modal
            pairElement.querySelector(".productFormPairModal").showModal();

            // select options
            let optionsParsed = JSON.parse(options);
            pairElement.querySelectorAll(`.productFormPairModalLabelSelect`).forEach(element => {
                element.value = optionsParsed[element.getAttribute("name")]
            });

            // gray out choices that are dead ends for this pair's current answers
            refreshPairModalDisabledOptions(pairElement);

        })
    });

    // close event
    section.querySelectorAll(".productFormPairModal").forEach(element => {
        element.addEventListener('close', function () {

            // save pair element
            let pairElement = this.closest(".productFormPair");

            // check if this input has no options, then we hide it (it means they added a product with different options and canclled)
            if (!pairElement.getAttribute("options")) {
                pairElement.classList.remove("active");
            }

        });
    })

    // trigger close modal
    section.querySelectorAll(".productFormPairModal,.productFormPairModalCancel,.productFormPairModalExit").forEach(element => {
        element.addEventListener("click", function (e) {
            if (e.target === this) {
                section.querySelector(".productFormPairModal[open]").close();
            }
        })
    });

    // form input events
    section.querySelectorAll(".productFormPairModalLabelSelect").forEach(element => element.addEventListener("change", function () {
        // recompute dead ends for the new answer and reset selects that just became invalid
        refreshPairModalDisabledOptions(this.closest(".productFormPair"));

        // check if the entire form is ready
        let form = this.closest(".productFormPairModalContent");

        // check if all inputs are entered
        let ready = true;
        form.querySelectorAll(".productFormPairModalLabelSelect").forEach(input => {
            if (input.selectedIndex === 0) {
                ready = false;
            }
        });

        // update update button
        form.querySelector(".productFormPairModalUpdate").disabled = !ready;
    }));

    // update pair
    section.querySelectorAll(".productFormPairModalContent").forEach(element => {
        element.addEventListener("submit", function (e) {
            e.preventDefault();

            // save pair element
            let pairElement = this.closest(".productFormPair");

            // set this option as active
            pairElement.classList.add("active");

            // update options attribute only if the option isn't the initial one
            let options = {};
            this.closest(".productFormPairModal").querySelectorAll(`.productFormPairModalLabelSelect`).forEach(element => {
                if (!element.value.includes("Choose")) {
                    options[element.getAttribute("name")] = element.value;
                }
            });

            pairElement.setAttribute("options", JSON.stringify(options));

            // close modal
            section.querySelector(".productFormPairModal[open]").close();

            updateProduct();
        });
    });

    // remove
    section.querySelectorAll(".productFormPairRemove").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = this.closest(".productFormPair");

            // remove active and options
            pairElement.classList.remove("active");
            pairElement.removeAttribute("options");

            // update product
            updateProduct();

            // check if there are no more left, reset the swiper to slide 1 and remove active classes on lebels
            if (section.querySelectorAll(".productFormPair.active").length === 0) {
                section.querySelector(".productFormSwiper").classList.add("active");
                section.querySelector(".productFormForm").classList.remove("active");
                section.querySelectorAll(".productFormOptionSlideLabel.active").forEach(element => element.classList.remove("active"));

                // with all answers cleared, recompute so only globally dead choices stay grayed
                refreshDisabledOptions();
                productFormSwiper.slideTo(0);
            }
        });
    })

    // same as first
    section.querySelector(".productFormActionSame").addEventListener("click", function () {
        // check for a free slot
        let nextFree = section.querySelector(".productFormPair:not(.active)");
        if (nextFree) {
            nextFree.classList.add("active");
            nextFree.setAttribute("options", section.querySelector(".productFormPair").getAttribute("options"));
        }
        updateProduct();
    });

    // new pair
    section.querySelector(".productFormActionNew").addEventListener("click", function () {
        //check for a free slot
        let nextFree = section.querySelector(".productFormPair:not(.active)");
        if (nextFree) {
            nextFree.classList.add("active");

            // gray out globally dead choices before the customer starts picking
            refreshPairModalDisabledOptions(nextFree);
            nextFree.querySelector(".productFormPairModal").showModal();
        }
    });

    function updateProduct() {
        // reset atc button (atc active)
        section.querySelector(".productFormATC").textContent = "Add To Cart";
        section.querySelector(".productFormATC").classList.add("active");
        section.querySelector(".productFormATC").classList.remove("disabled");
        section.querySelector(".productFormATC").classList.remove("message");

        // show terms
        // section.querySelector(".productFormTerms").classList.remove("active");

        // reset form data
        formData.items = [];
        section.querySelectorAll(".productFormPairTitle")?.forEach(element => element.classList.remove("active"));
        // hide error message
        section.querySelector(".productFormATC").classList.remove("active");
        section.querySelectorAll(".productFormPair.active").forEach((element, index) => {
            // reindex
            element.querySelector(".productFormPairTitle").textContent = `PAIR ${index + 1}`

            // add formdata
            let options = JSON.parse(element.getAttribute("options"));
            let item = getFormData(options, product.handle);

            // check if item is not found (variant can't be found)
            if (item === false || !item.available) {
                // hide atc button
                section.querySelector(".productFormATC").classList.add("active");

                // hide terms
                // section.querySelector(".productFormTerms").classList.add("active");

                let errorMsg = "Sorry, we don't offer a product that meets the selected options.";


                if (!item.available) {
                    errorMsg = "Sorry, this product is currently out of stock.";
                }

                if (item === false) {
                    errorMsg = "Unavailable — this selection is not currently part of our assortment";
                }


                section.querySelector('.productFormErrorMsg').textContent = errorMsg;

                // show error message
                section.querySelector(".productFormError").classList.add("active");

                // find that element
                let productFormPair = section.querySelector(`.productFormPair[options='${JSON.stringify(options)}']`);

                // indicate that this pair is invalid by setting title to active
                productFormPair.querySelector(".productFormPairTitle").classList.add("active");

                // log request
                let formData = new FormData();
                formData.set("handle", product.handle);
                formData.set("options", JSON.stringify(options));
                fetch("https://api.vktry.com/variant-not-found.php", {
                    method: "POST",
                    body: formData
                });

                return;
            }


            // show atc
            section.querySelector(".productFormATC").classList.remove("active");

            // show terms
            // section.querySelector(".productFormTerms").classList.remove("active");

            // hide error message
            section.querySelector(".productFormError")?.classList.remove("active");

            // check for duplicates (id and property, if you check the entire object, the id won't match)
            for (let i = 0; i < formData.items.length; i++) {
                if (formData.items[i].id === item.id && JSON.stringify(formData.items[i].properties) === JSON.stringify(item.properties)) {
                    formData.items[i].quantity++;
                    return;
                }
            }

            // add item to form data
            formData.items.push(item);

        });
    }

    // dynamic shoe size title
    section.querySelectorAll(".productFormOptionSlideLabel[data-group='gender']").forEach(element => {
        element.addEventListener("click", function () {
            // pass when option is not available
            if (this.classList.contains("soldOut")) {
                return;
            }
            section.querySelector('.productFormOptionSlideTitleGender').textContent = element.textContent;
        })
    })

    // locate the red note inside the size slide (only present when shoe_size_note setting is filled)
    const sizeSlide = section.querySelector(".productFormOptionSlideLabel[data-group='size']")?.closest(".productFormOptionSlide");
    const sizeRedNote = sizeSlide?.querySelector(".productFormOptionSlideRed");

    // keep the original note so sports without their own note fall back to it
    const sizeRedNoteHTML = sizeRedNote?.innerHTML;

    // show sport specific notes on the size slide when the sport changes
    section.querySelectorAll(".productFormOptionSlideLabel[data-group='sport']").forEach(element => {
        element.addEventListener("click", function () {
            // ignore blocked choices so the note only reflects real selections
            if (this.classList.contains("soldOut")) {
                return;
            }

            // nothing to update when the shoe_size_note setting is empty
            if (!sizeRedNote) {
                return;
            }

            // restore the original note so the slide stays in sync with the current sport
            sizeRedNote.innerHTML = sizeRedNoteHTML;

            // ice hockey replaces the note with its own sizing instruction
            if (this.dataset.value === "Ice Hockey") {
                sizeRedNote.innerHTML = `<p>Size up .5 size for Ice Hockey</p>`;
                return;
            }

            // cheerleading keeps the original note and adds its own instruction below it
            if (this.dataset.value === "Cheerleading") {
                sizeRedNote.insertAdjacentHTML("beforeend", `<div class="productFormOptionSlideRedCheerleading">For use in Nfinity shoes, size down 2 sizes</div>`);
            }
        });
    });


    /**************
     Product ATC
     ***************/

    section.querySelector(".productFormATC").addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        // add product
        await addProduct(formData);

        // stop loading
        this.classList.remove("loading");


        // check for upsell
        await openUpsell();

        // open cart
        await openCart();
    });

    /********************************** Shoe Size **********************************/


    // open shoe size modal
    document.querySelectorAll(".openShoeSize").forEach(element => {
        element.addEventListener("click", function () {
            // Find the correct shoe size modal

            // The modal to open is based on the sport
            // Gold: Basketball, fitness, racquet sports, running, volleyball, walking/hiking, everyday
            // Black: Baseball, boxing, football, golf, lacrosse, rugby, ultimate frisbee, [NEW -> ]Cheerleading, Track, Soccer
            // Red: REMOVED and uses black now, was Cheerleading, Track, Soccer
            let sport = document.querySelector(`.productFormOptionSlideLabel.active[data-group="sport"]`)?.dataset?.value;

            if (sport === "Basketball" || sport === "Fitness" || sport === "Tennis/Pickleball" || sport === "Running" || sport === "Volleyball" || sport === "Hiking" || sport === "Walking" || sport === "Other") {
                document.querySelector('#shoeSizeGold').showModal();
            } else {
                document.querySelector('#shoeSizeBlack').showModal();
            }

            document.querySelector("body").classList.add("noScroll");

        })
    });

    // open clog size modal
    document.querySelectorAll(".upsellSize")?.forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('#shoeSizeClog').showModal();
            document.querySelector("body").classList.add("noScroll");
        })
    });

    //close shoe size event listener
    document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
        element.addEventListener("click", async function () {
            let target = this.dataset.target;
            await closeSize(target);

        });
    });

    //close shoe size event listener
    document.querySelectorAll(".shoeSize")?.forEach(function (element) {
        element.addEventListener("click", async function (e) {
            if (e.target === this) {
                let target = element.id;
                await closeSize(target);

            }
        });
    });


    // close shoe size
    function closeSize(target) {
        document.querySelector(`#${target}`).close();
        document.querySelector("body").classList.remove("noScroll");
    }

    // register dialogs
    // wait for document to load first
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
            dialogPolyfill.registerDialog(element);
        });
    });


    /**************
     Product Gift
     ***************/

    // listen for "Request as gift" click
    section.querySelector(".productContentGiftLabelInput").addEventListener("click", function () {

        // show/hide the gift message in the ATC FORM
        section.querySelector(".productGift").classList.remove("active");
        if (this.checked) {
            section.querySelector(".productGift").classList.add("active");
        }
    });


    // Submit gift form
    section.querySelector('.productGiftFormSubmit').addEventListener('click', async function (e) {
        e.preventDefault();

        // create url params
        const giftParams = new URLSearchParams({
            fromName: document.querySelector(".productGiftFormName").value,
            handle: product.handle,
            formData: JSON.stringify(formData)
        }).toString();

        // send event to Klaviyo
        const response = await fetch(`https://api.vktry.com/send-a-gift.php`, {
            method: "POST",
            body: new URLSearchParams({
                fromName: document.querySelector(".productGiftFormName").value,
                toEmail: document.querySelector(".productGiftFormEmail").value,
                purchaseURL: `https://${window.location.hostname}/pages/send-gift?${giftParams}`,
            })
        })
            .then(response => response.json())

        // check for error
        if (response.error) {
            await Swal.fire({
                title: 'Error',
                text: response.error,
            });
            return;
        }

        // update text
        section.querySelector(".productGiftTxt").textContent = "Your email was sent with the VKTRYs you would like as a gift.";
        section.querySelector('.productGiftForm').classList.remove('active');
    });

    /**************
     Product Upsells
     ***************/

        // upsell swiper
    let upsellSwiper = new Swiper('#upsell .upsellSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: '#upsell .upsellSwiperFooterPag',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
            },
        });

    let upsellOptionalSwiper = new Swiper('#upsellOptional .upsellSwiper', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '#upsellOptional .upsellSwiperFooterPag',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },
    });

    // store the swiper slides to use for later
    let socksSlide = document.querySelector('#upsellSocks');
    let boostsSlide = document.querySelector('#upsellBoosts');
    let gripsSlide = document.querySelector('#upsellGrips');
    let clogsSlide = document.querySelector('#upsellClogs');
    let silverSlide = document.querySelector('#upsellSilver');
    let silverProduct = JSON.parse(document.querySelector('#upsellSilver').dataset.product)
    let additionalProperties;
    let tag = '';

    // map the sportToUpsell titles to the slides
    let upsellTitleToUpsellSlide = {
        "Ankle Boosts": boostsSlide,
        "Grip Socks": gripsSlide,
        "Propulsion Socks": socksSlide,
        "Recovery Clogs": clogsSlide,
        "Silver Insoles": silverSlide
    }

    // add to cart event listeners
    document.querySelectorAll(".upsellCheckout").forEach(element => {
        element.addEventListener("click", async function () {

            // Used in Discount Kit to target specific upsell products
            let discountProperty = '';

            // start loading
            this.classList.add("loading");

            // determine the first insole gender and size
            const firstPair = JSON.parse(document.querySelector(".productFormPair.active").getAttribute("options"));
            const firstPairGender = firstPair.gender;
            const firstPairSize = firstPair.size;

            // determine the variant id
            let variantID;
            let available = true;

            if (element.classList.contains("boosts")) {
                discountProperty = 'boosts_bundle';
                tag = 'boost upsell';
                if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 9)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 10.5))) {
                    variantID = 42757218402475; // medium
                } else {
                    variantID = 42757218435243; // large
                }
            } else if (element.classList.contains("silver")) {
                discountProperty = 'silver_free_upsell';
                tag = 'silver upsell';
                let silverUpsellEl = document.querySelector('#upsellSilver');
                let formData = JSON.parse(this.dataset.form);
                variantID = formData.id;

                // save additional properties
                additionalProperties = formData.properties;

            } else if (element.classList.contains("clogs")) {

                discountProperty = 'slides_bundle';
                tag = 'clog upsell';
                let clogsEl = document.querySelector('#upsellClogs');

                // find the correct clog OR slide variant based on the selected footwear type
                let clogOrSlideProduct = JSON.parse(clogsEl.querySelector(".upsellClogsOptionsGroupItemValuesLabelInput.type:checked").value);

                let color = clogsEl.querySelector(".upsellClogsOptionsGroupItemValuesLabelInput.color:checked").value;

                // find new variant based on the options
                let clogVariant = clogOrSlideProduct.variants.find((variant) => {
                    return (
                        variant.options[0] === color &&
                        variant.options[1] === clogsEl.querySelector('.upsellOptionsSelect[name="Gender"]').value &&
                        variant.options[2] === clogsEl.querySelector('.upsellOptionsSelect[name="Size"]').value
                    );
                });


                if (clogVariant.available) {
                    variantID = clogVariant.id;
                } else {
                    available = false;
                }
            } else if (element.classList.contains("grips")) {
                tag = 'grips upsell';
                if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 8)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 11))) {
                    variantID = 51654863061359 // medium
                } else if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 12)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 13))) {
                    variantID = 51654863094127; // large
                } else {
                    variantID = 51654863126895; // xlarge
                }
            } else {
                // compression socks
                discountProperty = 'compression_socks_upsell';
                tag = 'compression socks upsell';
                if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 7)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 9))) {
                    variantID = 42970044924075 // medium
                } else if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 12)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 14))) {
                    variantID = 42970045382827; // large
                } else {
                    variantID = 42970045415595; // xlarge
                }
            }

            // if this has already been added, remove it from the cart
            if (this.classList.contains("added")) {
                let cart = await getCart();

                // find the item
                let item = cart.items.find(item => item.variant_id === variantID);

                // if there is no item, return
                if (!item) {
                    this.textContent = "Add to Cart";
                    this.classList.remove("loading");
                    return;
                }

                await changeProduct({
                    id: item.key,
                    quantity: item.quantity - 1
                });

                this.classList.remove("added");
                this.textContent = "Add to Cart";
                this.classList.remove("loading");
                return;
            }


            // add
            if (available) {
                let formData = {
                    quantity: 1,
                    id: variantID,
                    properties: {
                        _upsell: true,
                        _upsell_tag: tag,
                        _discount_kit: discountProperty
                    }
                }

                // add additional properties if they exist (used for silver upsell)
                if (additionalProperties) {
                    formData.properties = {...formData.properties, ...additionalProperties};
                }

                await addProduct(formData);
            }

            // stop loading
            this.classList.remove("loading");

            // mandatory slides popup: close immediately after adding
            if (this.closest('#upsell')) {
                this.closest('.upsell').close();
                document.querySelector("body").classList.remove("noScroll");
                return;
            }

            // optional popup: toggle remove, advance slide, close when all added
            element.textContent = "Remove";
            this.classList.add("added");

            let optionalCheckouts = document.querySelectorAll('#upsellOptional .upsellCheckout');
            if ([...optionalCheckouts].every(btn => btn.classList.contains('added'))) {
                this.closest(".upsell").close();
                document.querySelector("body").classList.remove("noScroll");
                return;
            }

            if (this.closest(".swiper-slide").nextElementSibling) {
                upsellOptionalSwiper.slideNext();
            }
        });
    });

    // controls
    document.querySelector('#upsell .upsellContentControl.prev').addEventListener('click', function () {
        upsellSwiper.slidePrev();
    });

    document.querySelector('#upsell .upsellContentControl.next').addEventListener('click', function () {
        upsellSwiper.slideNext();
    });

    document.querySelector('#upsellOptional .upsellContentControl.prev').addEventListener('click', function () {
        upsellOptionalSwiper.slidePrev();
    });

    document.querySelector('#upsellOptional .upsellContentControl.next').addEventListener('click', function () {
        upsellOptionalSwiper.slideNext();
    });

    /**************
     Gorgias chat
     ***************/
    document.querySelector('.productChat')?.addEventListener('click', function () {
        // open gorgias chat
        if (GorgiasChat) {
            GorgiasChat.open()
        }

    })

    /********************************************** Upsell ***************************************/

        // top cover is based of weight (SILVER INSOLES)
    let weightToTopCover = {
            "70 - 99lbs": "L",
            "100 - 120lbs": "L",
            "121 - 150lbs": "L",
            "151 - 180lbs": "H",
            "181 - 210lbs": "H",
            "211 - 230lbs": "H",
            "231 - 260lbs": "H",
            "261lbs - Up": "H"
        };

    // Update Silver Upsell
    function updateSilverUpsell(autoselect = false) {
        let silverUpsellEl = document.querySelector('#upsellSilver');
        let firstPair = JSON.parse(document.querySelector(".productFormPair.active").getAttribute("options"));
        let firstPairSize = firstPair.size;


        // AutoSelect Age, weight, size, Gender, and sport if possible
        if (autoselect) {
            silverUpsellEl.querySelectorAll('.upsellOptionsSelect[name="weight"] option')?.forEach(option => option.selected = option.value === firstPair.weight);
            silverUpsellEl.querySelectorAll('.upsellOptionsSelect[name="age"] option')?.forEach(option => option.selected = option.value === firstPair.age);
            silverUpsellEl.querySelectorAll('.upsellOptionsSelect[name="gender"] option')?.forEach(option => option.selected = option.value === firstPair.gender);
            silverUpsellEl.querySelectorAll('.upsellOptionsSelect[name="sport"] option')?.forEach(option => option.selected = option.value === firstPair.sport);

            silverUpsellEl.querySelectorAll('.upsellOptionsSelect[name="size"] option')?.forEach(function (option) {
                let sizeSplit = option.value.split('-');
                if (sizeSplit[0] === firstPairSize || sizeSplit[1] === firstPairSize) {
                    option.selected = true;
                }
            })
        }

        // find the silver variant
        let silverWeight = silverUpsellEl.querySelector('.upsellOptionsSelect[name="weight"]').value;
        let silverAge = silverUpsellEl.querySelector('.upsellOptionsSelect[name="age"]').value;
        let silverSize = silverUpsellEl.querySelector('.upsellOptionsSelect[name="size"]').value;
        let silverGender = silverUpsellEl.querySelector('.upsellOptionsSelect[name="gender"]').value;
        let silverSport = silverUpsellEl.querySelector('.upsellOptionsSelect[name="sport"]').value;

        let topCover = weightToTopCover[silverWeight];

        if (
            silverGender === "Male" && silverSize === "5" ||
            silverGender === "Male" && silverSize === "5.5" ||
            silverGender === "Female" && silverSize === "7" ||
            silverGender === "Female" && silverSize === "7.5" ||
            silverGender === "Male" && silverSize === "6" ||
            silverGender === "Male" && silverSize === "6.5" ||
            silverGender === "Female" && silverSize === "8" ||
            silverGender === "Female" && silverSize === "8.5"

        ) {
            topCover = "L";
        }

        // 43-L -> 43-H
        // 44-L -> 44-H
        // 45-L -> 45-H
        if (
            silverGender === "Male" && silverSize === "11" ||
            silverGender === "Male" && silverSize === "11.5" ||
            silverGender === "Female" && silverSize === "13" ||
            silverGender === "Female" && silverSize === "13.5" ||
            silverGender === "Male" && silverSize === "12" ||
            silverGender === "Male" && silverSize === "12.5" ||
            silverGender === "Male" && silverSize === "13" ||
            silverGender === "Male" && silverSize === "13.5"
        ) {
            topCover = "H";
        }

        // athletes over 50 and 151-180 receive a topCover of L
        if (silverAge === "50 and Up" && silverWeight === "151 - 180lbs") {
            topCover = "L";
        }

        // option order is size, top cover, gender
        // find the correct variant based on the active options
        let variant = null;
        for (let i = 0; i < silverProduct.variants.length; i++) {

            // here comes the tricky part, Shopfiy might have 5-5.5 OR 5.5-6 ending on the top cover however we're going to receive a size of 5, 5.5 or 6.
            // We need to do a split and find an exact match
            if (
                // size
                silverProduct.variants[i].option1.split("-").includes(silverSize) &&
                // top cover
                silverProduct.variants[i].option2 === topCover &&
                // gender
                silverProduct.variants[i].option3 === silverGender
            ) {
                variant = silverProduct.variants[i];
                break;
            }
        }

        // save formData to the checkout button
        let formData = {
            quantity: 1,
            id: variant ? variant.id : null,
            properties: {
                "Age": silverAge,
                "Sport": silverSport,
                "Weight": silverWeight
            },
        }

        // save the form data
        formData = JSON.stringify(formData);
        silverUpsellEl.querySelector('.upsellCheckout.silver').setAttribute('data-form', formData);

        // no variant found
        if (!variant) {
            silverUpsellEl.querySelector('.upsellCheckout.silver').disabled = true;
            silverUpsellEl.querySelector('.upsellCheckout.silver').textContent = "Not Available";
            return;
        }
        let silverUpsell = variant;

        // unavailable variant
        if (!silverUpsell.available) {
            silverUpsellEl.querySelector('.upsellCheckout.silver').disabled = true;
            silverUpsellEl.querySelector('.upsellCheckout.silver').textContent = "Sold Out";
            return;
        }

        silverUpsellEl.querySelector('.upsellCheckout.silver').disabled = false;
        silverUpsellEl.querySelector('.upsellCheckout.silver').textContent = "Add To Cart";
    }


    function isSizeInRange(currentSize, min, max) {
        const range = currentSize.split('-').map(parseFloat);
        const size = parseFloat(range[0]);
        return !isNaN(size) && size >= min && size <= max;
    }

    // open mandatory clogs upsell
    async function openUpsell() {

        // get first pair options
        let firstPair = JSON.parse(section.querySelector(`.productFormPair.active`).getAttribute("options"));
        let firstPairGender = firstPair.gender;
        let firstPairSize = firstPair.size;

        // remove all swiper slides
        upsellSwiper.removeAllSlides();

        // show silver for the free silver template
        if (showSilver) {
            upsellSwiper.appendSlide(upsellTitleToUpsellSlide['Silver Insoles']);
            document.querySelectorAll('.upsellOptionsSelect.silver')?.forEach(element => {
                element.addEventListener("change", function () {
                    updateSilverUpsell();
                });
            });
            updateSilverUpsell(true);
        }

        // add slides (mandatory)
        upsellSwiper.appendSlide(upsellTitleToUpsellSlide['Recovery Clogs']);

        // reset clogs checkout button
        let clogElement = document.querySelector('#upsellClogs');
        clogElement.querySelector('.upsellCheckout').classList.remove('added');
        clogElement.querySelector('.upsellCheckout').disabled = false;
        clogElement.querySelector('.upsellCheckout').textContent = `Add to Cart`;

        // auto select the correct gender and size
        clogElement.querySelectorAll('.upsellOptionsSelect[name="Gender"] option').forEach(option => option.selected = option.value === firstPairGender);
        clogElement.querySelectorAll('.upsellOptionsSelect[name="Size"] option').forEach(function (option) {
            let sizeSplit = option.value.split('-');
            if (sizeSplit[0] === firstPairSize || sizeSplit[1] === firstPairSize) {
                option.selected = true;
            }
        });

        // find the variant based on the selected footwear type and color
        let clogOrSlideProduct = JSON.parse(clogElement.querySelector('.upsellClogsOptionsGroupItemValuesLabelInput.type:checked').value);
        syncClogsColors(clogElement, clogOrSlideProduct.handle);
        let color = clogElement.querySelector('.upsellClogsOptionsGroupItemValuesLabelInput.color:checked')?.value;
        let gender = clogElement.querySelector('.upsellOptionsSelect[name="Gender"]')?.value

        disableUnavailableFootwearOptions(clogOrSlideProduct, color, gender);

        // update the type and color titles
        const idToType = {
            "14723692167535": "Recovery Clogs",
            "14804854833519": "Recovery Slides"
        }
        clogElement.querySelector('.upsellClogsOptionsGroupItemControlsTitleVal.type').textContent = idToType[clogOrSlideProduct.id];
        clogElement.querySelector('.upsellClogsOptionsGroupItemControlsTitleVal.color').textContent = color;

        let clogVariant = clogOrSlideProduct.variants.find((variant) => {
            return (
                variant.options[0] === color &&
                variant.options[1] === clogElement.querySelector('.upsellOptionsSelect[name="Gender"]').value &&
                variant.options[2] === clogElement.querySelector('.upsellOptionsSelect[name="Size"]').value
            );
        });

        if (!clogVariant) {
            clogElement.querySelector('.upsellCheckout').disabled = true;
            clogElement.querySelector('.upsellCheckout').textContent = 'Unavailable';
        } else {
            // sync the hero image to the selected footwear
            clogElement.querySelector('.upsellHero').src = clogVariant.featured_image.src + '&width=400';
        }

        // mandatory popup has one slide — no controls
        document.querySelectorAll('#upsell .upsellContentControl').forEach(el => el.classList.remove("active"));
        document.querySelector('#upsell .upsellSwiperFooter').classList.remove("active");

        // open the mandatory upsell
        document.querySelector('#upsell').showModal();
        document.querySelector("body").classList.add("noScroll");

        // wait for mandatory popup to close (user adds slides to cart)
        await new Promise(resolve => {
            document.querySelector('#upsell').addEventListener("close", resolve, {once: true});
        });

        // open the optional upsell (boosts + grip socks)
        // await openOptionalUpsell();
    }

    async function openOptionalUpsell() {
        // reset optional checkout buttons
        document.querySelectorAll('#upsellOptional .upsellCheckout').forEach(btn => {
            btn.classList.remove('added');
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
        });

        // setup optional swiper with boosts + grip socks
        upsellOptionalSwiper.removeAllSlides();
        upsellOptionalSwiper.appendSlide(boostsSlide);
        upsellOptionalSwiper.appendSlide(gripsSlide);

        // show controls for two slides
        document.querySelectorAll('#upsellOptional .upsellContentControl').forEach(el => el.classList.add("active"));
        document.querySelector('#upsellOptional .upsellSwiperFooter').classList.add("active");

        // open optional upsell
        document.querySelector('#upsellOptional').showModal();
        document.querySelector("body").classList.add("noScroll");

        // wait for optional popup to close
        await new Promise(resolve => {
            document.querySelector('#upsellOptional').addEventListener("close", resolve, {once: true});
        });

        document.querySelector("body").classList.remove("noScroll");
    }

    // clog upsell options changes
    document.querySelectorAll('#upsellClogs select, #upsellClogs input').forEach(element => {
        element.addEventListener('change', (e) => {
            updateClogsUpsell();
        })
    })

    // clogs and slides carry different colors, so only show the swatches the selected footwear type offers
    function syncClogsColors(clogElement, handle) {
        clogElement.querySelectorAll('.upsellClogsOptionsGroupItemValuesLabel.color').forEach(label => {
            let offered = label.dataset.handles.split(' ').includes(handle);
            label.classList.toggle('active', offered);

            // drop the selection when the new type does not come in this color
            if (!offered) {
                label.querySelector('.upsellClogsOptionsGroupItemValuesLabelInput.color').checked = false;
            }
        });

        // keep a color selected once the previous one is dropped
        if (clogElement.querySelector('.upsellClogsOptionsGroupItemValuesLabelInput.color:checked')) {
            return;
        }
        clogElement.querySelector('.upsellClogsOptionsGroupItemValuesLabel.color.active .upsellClogsOptionsGroupItemValuesLabelInput.color').checked = true;
    }

    function disableUnavailableFootwearOptions(footwearProduct, selectedColor, selectedGender) {
        // Scope the clogs popup
        const section = document.querySelector("#upsellClogs");
        // Set all the options to disabled
        const sizeOptions = section.querySelectorAll(".upsellOptionsSelect[name='Size'] option");
        sizeOptions.forEach((option) => {
            option.disabled = true;
        })

        // Enable options that have available variant
        footwearProduct.variants.forEach(variant => {
            if (variant.options.includes(selectedColor) && variant.options.includes(selectedGender) && variant.available) {
                Array.from(sizeOptions).find(option => variant.options.includes(option.value)).disabled = false;
            }
        });

        // update the selection to first available size option if the currently selected one is unavailable
        if (section.querySelector(".upsellOptionsSelect[name='Size'] option:checked").disabled) {
            section.querySelector(".upsellOptionsSelect[name='Size'] option:not(:disabled)").selected = true;
        }
    }

    // update the clogs ATC based on the selected clog inputs
    function updateClogsUpsell() {
        let clogElement = document.querySelector('#upsellClogs');


        // find the variant based on the selected footwear type and color
        let clogOrSlideProduct = JSON.parse(clogElement.querySelector('.upsellClogsOptionsGroupItemValuesLabelInput.type:checked').value);
        syncClogsColors(clogElement, clogOrSlideProduct.handle);
        let color = clogElement.querySelector('.upsellClogsOptionsGroupItemValuesLabelInput.color:checked')?.value;
        let gender = clogElement.querySelector('.upsellOptionsSelect[name="Gender"]')?.value

        disableUnavailableFootwearOptions(clogOrSlideProduct, color, gender);


        // find new variant based on the selected clog options
        let clogVariant = clogOrSlideProduct.variants.find((variant) => {
            return (
                variant.options[0] === color &&
                variant.options[1] === clogElement.querySelector('.upsellOptionsSelect[name="Gender"]').value &&
                variant.options[2] === clogElement.querySelector('.upsellOptionsSelect[name="Size"]').value
            );
        });


        // update titles
        const idToType = {
            "14723692167535": "Recovery Clogs",
            "14804854833519": "Recovery Slides"
        }
        clogElement.querySelector('.upsellClogsOptionsGroupItemControlsTitleVal.type').textContent = idToType[clogOrSlideProduct.id];
        clogElement.querySelector('.upsellClogsOptionsGroupItemControlsTitleVal.color').textContent = color;


        if (!clogVariant) {
            // disable the clog upsell
            document.querySelector('#upsellClogs').querySelector('.upsellCheckout').disabled = true;
            document.querySelector('#upsellClogs').querySelector('.upsellCheckout').textContent = 'Unavailable';
            return
        }

        // update image
        clogElement.querySelector('.upsellHero').src = clogVariant.featured_image.src + '&width=400';

        document.querySelector('#upsellClogs').querySelector('.upsellCheckout').disabled = false;
        // let total = price(document.querySelector('.upsellCheckout.clogs').dataset.salePrice, true);
        document.querySelector('#upsellClogs').querySelector('.upsellCheckout').textContent = `Add to Cart`;
    }


    // close events (mandatory #upsell cannot be dismissed by backdrop)
    document.querySelectorAll(".upsell").forEach(element => {
        element.addEventListener("click", function (e) {
            if (e.target === this && element.id !== 'upsell') {
                this.close();
                document.querySelector("body").classList.remove("noScroll");
            }
        });
    });

    // close upsell via button
    document.querySelectorAll(".upsellClose").forEach(element => {
        element.addEventListener("click", function () {
            this.closest(".upsell").close();
            document.querySelector("body").classList.remove("noScroll");
        });
    });


    // register dialogs
    dialogPolyfill.registerDialog(document.querySelector("#upsell"));
    dialogPolyfill.registerDialog(document.querySelector("#upsellOptional"));

    /**************
     Money Back
     ***************/

    // open moneyBack dialog
    document.querySelectorAll('.openMoneyBack').forEach(function (element) {
        element.addEventListener('click', function () {
            document.querySelector("#moneyBack").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    })

    // close moneyBack
    function closePopup() {
        document.querySelector("#moneyBack").close();
        document.querySelector("body").classList.remove("noScroll");
    }

    // close moneyBack event listener
    document.querySelectorAll(".moneyBackClose").forEach(function (element) {
        element.addEventListener("click", closePopup);
    });

    document.querySelector("#moneyBack").addEventListener("click", function (e) {
        if (e.target === this) {
            closePopup();
        }
    })

    // close event
    document.querySelector("#moneyBack").addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    // register dialog
    dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));


    // delete the hidden upsells from the DOM
    document.querySelector('.hiddenUpsells').remove();


    // sticky atc
    // if productContentBodyMain is not present, show sticky
    window.addEventListener("scroll", function () {
        let target = document.querySelector("#productContentBodyMain");

        let rect = target.getBoundingClientRect();
        if (rect.top <= 0) {
            document.querySelector(".productSticky").classList.add("active");
        } else {
            document.querySelector(".productSticky").classList.remove("active");
        }

    });

    // listen for click
    document.querySelector(".productSticky")?.addEventListener("click", function () {
        const targetPosition = document.querySelector('#productContentBodyMain').getBoundingClientRect().top + window.scrollY - 120;

        // Scroll to the product form
        window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
        });

    });


}())